export function validateHeader(data, setError) {
    const errors = [];
    if (!data.title) errors.push('title');
    if (!data.startDate) errors.push('startDate');
    if (errors.length) {
        setError(errors);
        return true;
    }
    return false;
}
